import React, { useState } from 'react'

const Footer = () => {
    let date=new Date().toLocaleTimeString();
    const [time,setTime]=useState(date);
    setTimeout(()=>{
        setTime(new Date().toLocaleTimeString());
    },1000)
  return (
    <p className="text-center">
        &copy;Krishna - {time}
    </p>
  )
}

export default Footer